var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "padd30 seller-style relative" },
    [
      _c("h2", { staticClass: "f18 fb normal gray_2" }, [_vm._v("货品管理")]),
      _c("div", { staticClass: "box20" }),
      _c(
        "div",
        { staticClass: "good-search" },
        [
          _c("el-input", {
            staticClass: "mar10_r",
            attrs: { placeholder: "请输入内容" },
            model: {
              value: _vm.good_name,
              callback: function($$v) {
                _vm.good_name = typeof $$v === "string" ? $$v.trim() : $$v
              },
              expression: "good_name"
            }
          }),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.searchGood } },
            [_vm._v("搜索")]
          )
        ],
        1
      ),
      _c(
        "el-tabs",
        {
          on: { "tab-click": _vm.handleClick },
          model: {
            value: _vm.relationType,
            callback: function($$v) {
              _vm.relationType = $$v
            },
            expression: "relationType"
          }
        },
        [
          _c("el-tab-pane", { attrs: { label: "全部货品", value: "0" } }, [
            _c(
              "div",
              { staticClass: "bor_f0 mar10-t" },
              [
                _c(
                  "div",
                  { staticClass: "flex items-center b_f5 box60 bor_bottom_f0" },
                  [
                    _c("div", { staticClass: "w40 pad25-l" }, [
                      _vm._v("销售商品")
                    ]),
                    _c("div", { staticClass: "pad25-l" }, [_vm._v("采购商品")])
                  ]
                ),
                _vm.goodsList.length
                  ? _vm._l(_vm.goodsList, function(item) {
                      return _c("div", { staticClass: "flex bor_bottom_f0" }, [
                        _c(
                          "div",
                          {
                            staticClass: "w40 good-detail flex relative h-auto"
                          },
                          [
                            _c("div", { staticClass: "mar-auto" }, [
                              _c("div", { staticClass: "box30" }),
                              _c("div", { staticClass: "flex pad15-tb" }, [
                                _c("img", {
                                  staticClass: "good-change-icon",
                                  attrs: {
                                    src: require("./images/good-change.png"),
                                    alt: ""
                                  }
                                }),
                                _c("img", {
                                  attrs: { src: item.picUrl, alt: "" }
                                }),
                                _c("div", { staticClass: "flex1" }, [
                                  _c("p", { staticClass: "ellipsis w240" }, [
                                    _vm._v(_vm._s(item.name))
                                  ]),
                                  _c("p", { staticClass: "f12" }, [
                                    _vm._v("规格：" + _vm._s(item.spec))
                                  ]),
                                  _c("div", { staticClass: "box10" }),
                                  _c("p", [
                                    _c("span", { staticClass: "pad20-r" }, [
                                      _vm._v("数量：1")
                                    ]),
                                    _c("span", [
                                      _vm._v(
                                        "价格：￥" + _vm._s(item.marketPriceStr)
                                      )
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ]
                        ),
                        _c("div", { staticClass: "flex1 flex" }, [
                          item.supplyGoodsRelationList &&
                          item.supplyGoodsRelationList.length > 0
                            ? _c(
                                "div",
                                { staticClass: "flex1" },
                                [
                                  _vm._l(item.supplyGoodsRelationList, function(
                                    purchaseGoods,
                                    index
                                  ) {
                                    return [
                                      index < 3
                                        ? _c(
                                            "div",
                                            {
                                              key: index,
                                              staticClass: "flex flex1"
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "good-detail w75"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "flex" },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "flex1 pad15-tb",
                                                          class: {
                                                            bor_bottom_f0:
                                                              (item
                                                                .supplyGoodsRelationList
                                                                .length -
                                                                1 >
                                                                index &&
                                                                index != 2) ||
                                                              !item.isShowOrNone
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "lin_20 mar10-b"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "供应商：" +
                                                                  _vm._s(
                                                                    purchaseGoods.shopName
                                                                  )
                                                              )
                                                            ]
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                " flex"
                                                            },
                                                            [
                                                              _c("img", {
                                                                attrs: {
                                                                  src:
                                                                    purchaseGoods.picUrl,
                                                                  alt: ""
                                                                }
                                                              }),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "flex1"
                                                                },
                                                                [
                                                                  _c(
                                                                    "p",
                                                                    {
                                                                      staticClass:
                                                                        "ellipsis w200"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          purchaseGoods.purchaseGoodsName
                                                                        )
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "p",
                                                                    {
                                                                      staticClass:
                                                                        "f12"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "规格：" +
                                                                          _vm._s(
                                                                            purchaseGoods.spec
                                                                          )
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _c("div", {
                                                                    staticClass:
                                                                      "box10"
                                                                  }),
                                                                  _c("p", [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "pad20-r"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "数量：" +
                                                                            _vm._s(
                                                                              purchaseGoods.purchaseGoodsQuantity
                                                                            )
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _c("span", [
                                                                      _vm._v(
                                                                        "价格：￥" +
                                                                          _vm._s(
                                                                            purchaseGoods.marketPriceStr
                                                                          )
                                                                      )
                                                                    ])
                                                                  ]),
                                                                  _c("p", [
                                                                    purchaseGoods.purchaseGoodsTaxRatio !==
                                                                    0
                                                                      ? _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              "税率： " +
                                                                                _vm._s(
                                                                                  purchaseGoods.purchaseGoodsTaxRatio
                                                                                ) +
                                                                                " %"
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              "税率：免税"
                                                                            )
                                                                          ]
                                                                        )
                                                                  ])
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      ),
                                                      purchaseGoods.isDefault ==
                                                        1 &&
                                                      item
                                                        .supplyGoodsRelationList
                                                        .length > 1
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "flex w110 align_flex_end justify-center pointer flex_column"
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.upGoodSetting(
                                                                        index,
                                                                        purchaseGoods,
                                                                        item
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [_vm._v("编辑")]
                                                              )
                                                            ]
                                                          )
                                                        : _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "flex w110 align_flex_end justify-center pointer flex_column"
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.upGoodSetting(
                                                                        index,
                                                                        purchaseGoods,
                                                                        item
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [_vm._v("编辑")]
                                                              ),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "pad10_t",
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.goodSetting(
                                                                        purchaseGoods,
                                                                        item
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "取消关联"
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              purchaseGoods.isDefault == 1
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "flex flex1 items-center justify-around flex_column f12 text-center pad10-lr ",
                                                      class: {
                                                        bor_bottom_f0:
                                                          (item
                                                            .supplyGoodsRelationList
                                                            .length -
                                                            1 >
                                                            index &&
                                                            index != 2) ||
                                                          !item.isShowOrNone
                                                      }
                                                    },
                                                    [
                                                      _c("span", [
                                                        _vm._v(
                                                          "默认为所有客户"
                                                        ),
                                                        _c("br"),
                                                        _vm._v(
                                                          "(除已设置的客户之外)"
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                : _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "flex flex1 items-center justify-around flex_column f12 text-center pad10-lr",
                                                      class: {
                                                        bor_bottom_f0:
                                                          (item
                                                            .supplyGoodsRelationList
                                                            .length -
                                                            1 >
                                                            index &&
                                                            index != 2) ||
                                                          !item.isShowOrNone
                                                      }
                                                    },
                                                    [
                                                      purchaseGoods.customerNameList
                                                        ? _c("span", [
                                                            _vm._v(
                                                              "\n                        " +
                                                                _vm._s(
                                                                  purchaseGoods.customerNameList.split(
                                                                    ","
                                                                  )[0]
                                                                ) +
                                                                "等 " +
                                                                _vm._s(
                                                                  purchaseGoods.customerNameList.split(
                                                                    ","
                                                                  ).length
                                                                ) +
                                                                "个客户\n                      "
                                                            )
                                                          ])
                                                        : _vm._e(),
                                                      _c(
                                                        "el-button",
                                                        {
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.openCustomerPop(
                                                                purchaseGoods,
                                                                item
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [_vm._v("编辑客户")]
                                                      )
                                                    ],
                                                    1
                                                  )
                                            ]
                                          )
                                        : _vm._e(),
                                      index > 2
                                        ? _c(
                                            "div",
                                            {
                                              key: index,
                                              staticClass: "flex flex1",
                                              class: { none: item.isShowOrNone }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "good-detail w75"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "flex" },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "flex1 pad15-tb",
                                                          class: {
                                                            bor_bottom_f0:
                                                              item
                                                                .supplyGoodsRelationList
                                                                .length -
                                                                1 >
                                                              index
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "lin_20 mar10-b"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "供应商：" +
                                                                  _vm._s(
                                                                    purchaseGoods.shopName
                                                                  )
                                                              )
                                                            ]
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                " flex"
                                                            },
                                                            [
                                                              _c("img", {
                                                                attrs: {
                                                                  src:
                                                                    purchaseGoods.picUrl,
                                                                  alt: ""
                                                                }
                                                              }),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "flex1"
                                                                },
                                                                [
                                                                  _c(
                                                                    "p",
                                                                    {
                                                                      staticClass:
                                                                        "ellipsis w200"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          purchaseGoods.purchaseGoodsName
                                                                        )
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "p",
                                                                    {
                                                                      staticClass:
                                                                        "f12"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "规格：" +
                                                                          _vm._s(
                                                                            purchaseGoods.spec
                                                                          )
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _c("div", {
                                                                    staticClass:
                                                                      "box10"
                                                                  }),
                                                                  _c("p", [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "pad20-r"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "数量：" +
                                                                            _vm._s(
                                                                              purchaseGoods.purchaseGoodsQuantity
                                                                            )
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _c("span", [
                                                                      _vm._v(
                                                                        "价格：￥" +
                                                                          _vm._s(
                                                                            purchaseGoods.marketPriceStr
                                                                          )
                                                                      )
                                                                    ])
                                                                  ]),
                                                                  _c("p", [
                                                                    purchaseGoods.purchaseGoodsTaxRatio !==
                                                                    0
                                                                      ? _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              "税率： " +
                                                                                _vm._s(
                                                                                  purchaseGoods.purchaseGoodsTaxRatio
                                                                                ) +
                                                                                " %"
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              "税率：免税"
                                                                            )
                                                                          ]
                                                                        )
                                                                  ])
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      ),
                                                      purchaseGoods.isDefault ==
                                                      1
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "flex w110 align_flex_end justify-center pointer flex_column"
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.upGoodSetting(
                                                                        index,
                                                                        purchaseGoods,
                                                                        item
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [_vm._v("编辑")]
                                                              )
                                                            ]
                                                          )
                                                        : _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "flex w110 align_flex_end justify-center pointer flex_column"
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.upGoodSetting(
                                                                        index,
                                                                        purchaseGoods,
                                                                        item
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [_vm._v("编辑")]
                                                              ),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "pad10_t",
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.goodSetting(
                                                                        purchaseGoods,
                                                                        item
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "取消关联"
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              purchaseGoods.isDefault == 1
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "flex flex1 items-center justify-around flex_column f12 text-center pad10-lr",
                                                      class: {
                                                        bor_bottom_f0:
                                                          item
                                                            .supplyGoodsRelationList
                                                            .length -
                                                            1 >
                                                          index
                                                      }
                                                    },
                                                    [
                                                      _c("span", [
                                                        _vm._v(
                                                          "默认为所有客户"
                                                        ),
                                                        _c("br"),
                                                        _vm._v(
                                                          "(除已设置的客户之外)"
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                : _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "flex flex1 items-center justify-around flex_column f12 text-center pad10-lr",
                                                      class: {
                                                        bor_bottom_f0:
                                                          item
                                                            .supplyGoodsRelationList
                                                            .length -
                                                            1 >
                                                          index
                                                      }
                                                    },
                                                    [
                                                      purchaseGoods.customerNameList
                                                        ? _c("span", [
                                                            _vm._v(
                                                              "\n                        " +
                                                                _vm._s(
                                                                  purchaseGoods.customerNameList.split(
                                                                    ","
                                                                  )[0]
                                                                ) +
                                                                "等 " +
                                                                _vm._s(
                                                                  purchaseGoods.customerNameList.split(
                                                                    ","
                                                                  ).length
                                                                ) +
                                                                "个客户\n                      "
                                                            )
                                                          ])
                                                        : _vm._e(),
                                                      _c(
                                                        "el-button",
                                                        {
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.openCustomerPop(
                                                                purchaseGoods,
                                                                item
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [_vm._v("编辑客户")]
                                                      )
                                                    ],
                                                    1
                                                  )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  }),
                                  item.supplyGoodsRelationList.length > 3
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "w75 h45 text-center good-more bor_right_f0"
                                        },
                                        [
                                          !item.isShowOrNone
                                            ? _c("img", {
                                                staticClass: "pointer",
                                                attrs: {
                                                  src: require("./images/pack-up.png"),
                                                  alt: ""
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.isShowOrNone(
                                                      item
                                                    )
                                                  }
                                                }
                                              })
                                            : _vm._e(),
                                          item.isShowOrNone
                                            ? _c("img", {
                                                staticClass: "pointer",
                                                attrs: {
                                                  src: require("./images/unfold.png"),
                                                  alt: ""
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.isShowOrNone(
                                                      item
                                                    )
                                                  }
                                                }
                                              })
                                            : _vm._e()
                                        ]
                                      )
                                    : _vm._e(),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "w75 h45 text-center good-more bor_right_f0"
                                    },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: { icon: "el-icon-plus" },
                                          on: {
                                            click: function($event) {
                                              return _vm.addGoodSetting(item)
                                            }
                                          }
                                        },
                                        [_vm._v("添加")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                2
                              )
                            : _c("div", { staticClass: "flex1" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "good-detail w75 h-100 flex items-center justify-center flex_column"
                                  },
                                  [
                                    _c("div", { staticClass: "f12 pad5_b" }, [
                                      _vm._v("暂无关联商品")
                                    ]),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { icon: "el-icon-plus" },
                                        on: {
                                          click: function($event) {
                                            return _vm.addGoodSetting(item)
                                          }
                                        }
                                      },
                                      [_vm._v("添加")]
                                    )
                                  ],
                                  1
                                )
                              ])
                        ])
                      ])
                    })
                  : _c("div", { staticClass: "t_center pad30-t pad30-b" }, [
                      _vm._v("暂无数据")
                    ])
              ],
              2
            )
          ]),
          _c("el-tab-pane", { attrs: { label: "未关联", value: "1" } }, [
            _c(
              "div",
              { staticClass: "bor_f0 mar10-t" },
              [
                _c(
                  "div",
                  { staticClass: "flex items-center b_f5 box60 bor_bottom_f0" },
                  [
                    _c("div", { staticClass: "w40 pad25-l" }, [
                      _vm._v("销售商品")
                    ]),
                    _c("div", { staticClass: "pad25-l" }, [_vm._v("采购商品")])
                  ]
                ),
                _vm.goodsList.length
                  ? _vm._l(_vm.goodsList, function(item) {
                      return _c("div", { staticClass: "flex bor_bottom_f0" }, [
                        _c(
                          "div",
                          {
                            staticClass: "w40 good-detail flex relative h-auto"
                          },
                          [
                            _c("div", { staticClass: "mar-auto" }, [
                              _c("div", { staticClass: "box30" }),
                              _c("div", { staticClass: "flex pad15-tb" }, [
                                _c("img", {
                                  staticClass: "good-change-icon",
                                  attrs: {
                                    src: require("./images/good-change.png"),
                                    alt: ""
                                  }
                                }),
                                _c("img", {
                                  attrs: { src: item.picUrl, alt: "" }
                                }),
                                _c("div", { staticClass: "flex1" }, [
                                  _c("p", { staticClass: "ellipsis w240" }, [
                                    _vm._v(_vm._s(item.name))
                                  ]),
                                  _c("p", { staticClass: "f12" }, [
                                    _vm._v("规格：" + _vm._s(item.spec))
                                  ]),
                                  _c("div", { staticClass: "box10" }),
                                  _c("p", [
                                    _c("span", { staticClass: "pad20-r" }, [
                                      _vm._v("数量：1")
                                    ]),
                                    _c("span", [
                                      _vm._v(
                                        "价格：￥" + _vm._s(item.marketPriceStr)
                                      )
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ]
                        ),
                        _c("div", { staticClass: "flex1" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "good-detail w75 h-100 flex items-center justify-center flex_column"
                            },
                            [
                              _c("div", { staticClass: "f12 pad5_b" }, [
                                _vm._v("暂无关联商品")
                              ]),
                              _c(
                                "el-button",
                                {
                                  attrs: { icon: "el-icon-plus" },
                                  on: {
                                    click: function($event) {
                                      return _vm.addGoodSetting(item)
                                    }
                                  }
                                },
                                [_vm._v("添加")]
                              )
                            ],
                            1
                          )
                        ])
                      ])
                    })
                  : _c("div", { staticClass: "t_center pad30-t pad30-b" }, [
                      _vm._v("暂无数据")
                    ])
              ],
              2
            )
          ]),
          _c("el-tab-pane", { attrs: { label: "已关联", value: "2" } }, [
            _c(
              "div",
              { staticClass: "bor_f0 mar10-t" },
              [
                _c(
                  "div",
                  { staticClass: "flex items-center b_f5 box60 bor_bottom_f0" },
                  [
                    _c("div", { staticClass: "w40 pad25-l" }, [
                      _vm._v("销售商品")
                    ]),
                    _c("div", { staticClass: "pad25-l" }, [_vm._v("采购商品")])
                  ]
                ),
                _vm.goodsList.length
                  ? _vm._l(_vm.goodsList, function(item) {
                      return _c("div", { staticClass: "flex bor_bottom_f0" }, [
                        _c(
                          "div",
                          {
                            staticClass: "w40 good-detail flex relative h-auto"
                          },
                          [
                            _c("div", { staticClass: "mar-auto" }, [
                              _c("div", { staticClass: "box30" }),
                              _c("div", { staticClass: "flex pad15-tb" }, [
                                _c("img", {
                                  staticClass: "good-change-icon",
                                  attrs: {
                                    src: require("./images/good-change.png"),
                                    alt: ""
                                  }
                                }),
                                _c("img", {
                                  attrs: { src: item.picUrl, alt: "" }
                                }),
                                _c("div", { staticClass: "flex1" }, [
                                  _c("p", { staticClass: "ellipsis w240" }, [
                                    _vm._v(_vm._s(item.name))
                                  ]),
                                  _c("p", { staticClass: "f12" }, [
                                    _vm._v("规格：" + _vm._s(item.spec))
                                  ]),
                                  _c("div", { staticClass: "box10" }),
                                  _c("p", [
                                    _c("span", { staticClass: "pad20-r" }, [
                                      _vm._v("数量：1")
                                    ]),
                                    _c("span", [
                                      _vm._v(
                                        "价格：￥" + _vm._s(item.marketPriceStr)
                                      )
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ]
                        ),
                        _c("div", { staticClass: "flex1 flex" }, [
                          item.supplyGoodsRelationList &&
                          item.supplyGoodsRelationList.length
                            ? _c(
                                "div",
                                { staticClass: "flex1" },
                                [
                                  _vm._l(item.supplyGoodsRelationList, function(
                                    purchaseGoods,
                                    index
                                  ) {
                                    return [
                                      index < 3
                                        ? _c(
                                            "div",
                                            {
                                              key: index,
                                              staticClass: "flex flex1"
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "good-detail w75"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "flex" },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "flex1 pad15-tb",
                                                          class: {
                                                            bor_bottom_f0:
                                                              (item
                                                                .supplyGoodsRelationList
                                                                .length -
                                                                1 >
                                                                index &&
                                                                index != 2) ||
                                                              !item.isShowOrNone
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "lin_20 mar10-b"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "供应商：" +
                                                                  _vm._s(
                                                                    purchaseGoods.shopName
                                                                  )
                                                              )
                                                            ]
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                " flex"
                                                            },
                                                            [
                                                              _c("img", {
                                                                attrs: {
                                                                  src:
                                                                    purchaseGoods.picUrl,
                                                                  alt: ""
                                                                }
                                                              }),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "flex1"
                                                                },
                                                                [
                                                                  _c(
                                                                    "p",
                                                                    {
                                                                      staticClass:
                                                                        "ellipsis w200"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          purchaseGoods.purchaseGoodsName
                                                                        )
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "p",
                                                                    {
                                                                      staticClass:
                                                                        "f12"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "规格：" +
                                                                          _vm._s(
                                                                            purchaseGoods.spec
                                                                          )
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _c("div", {
                                                                    staticClass:
                                                                      "box10"
                                                                  }),
                                                                  _c("p", [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "pad20-r"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "数量：" +
                                                                            _vm._s(
                                                                              purchaseGoods.purchaseGoodsQuantity
                                                                            )
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _c("span", [
                                                                      _vm._v(
                                                                        "价格：￥" +
                                                                          _vm._s(
                                                                            purchaseGoods.marketPriceStr
                                                                          )
                                                                      )
                                                                    ])
                                                                  ]),
                                                                  _c("p", [
                                                                    purchaseGoods.purchaseGoodsTaxRatio !==
                                                                    0
                                                                      ? _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              "税率： " +
                                                                                _vm._s(
                                                                                  purchaseGoods.purchaseGoodsTaxRatio
                                                                                ) +
                                                                                " %"
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              "税率：免税"
                                                                            )
                                                                          ]
                                                                        )
                                                                  ])
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      ),
                                                      purchaseGoods.isDefault ==
                                                        1 &&
                                                      item
                                                        .supplyGoodsRelationList
                                                        .length > 1
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "flex w110 align_flex_end justify-center pointer flex_column"
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.upGoodSetting(
                                                                        index,
                                                                        purchaseGoods,
                                                                        item
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [_vm._v("编辑")]
                                                              )
                                                            ]
                                                          )
                                                        : _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "flex w110 align_flex_end justify-center pointer flex_column"
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.upGoodSetting(
                                                                        index,
                                                                        purchaseGoods,
                                                                        item
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [_vm._v("编辑")]
                                                              ),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "pad10_t",
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.goodSetting(
                                                                        purchaseGoods,
                                                                        item
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "取消关联"
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              purchaseGoods.isDefault == 1
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "flex flex1 items-center justify-around flex_column f12 text-center pad10-lr ",
                                                      class: {
                                                        bor_bottom_f0:
                                                          (item
                                                            .supplyGoodsRelationList
                                                            .length -
                                                            1 >
                                                            index &&
                                                            index != 2) ||
                                                          !item.isShowOrNone
                                                      }
                                                    },
                                                    [
                                                      _c("span", [
                                                        _vm._v(
                                                          "默认为所有客户"
                                                        ),
                                                        _c("br"),
                                                        _vm._v(
                                                          "(除已设置的客户之外)"
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                : _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "flex flex1 items-center justify-around flex_column f12 text-center pad10-lr",
                                                      class: {
                                                        bor_bottom_f0:
                                                          (item
                                                            .supplyGoodsRelationList
                                                            .length -
                                                            1 >
                                                            index &&
                                                            index != 2) ||
                                                          !item.isShowOrNone
                                                      }
                                                    },
                                                    [
                                                      purchaseGoods.customerNameList
                                                        ? _c("span", [
                                                            _vm._v(
                                                              "\n                        " +
                                                                _vm._s(
                                                                  purchaseGoods.customerNameList.split(
                                                                    ","
                                                                  )[0]
                                                                ) +
                                                                "等 " +
                                                                _vm._s(
                                                                  purchaseGoods.customerNameList.split(
                                                                    ","
                                                                  ).length
                                                                ) +
                                                                "个客户\n                      "
                                                            )
                                                          ])
                                                        : _vm._e(),
                                                      _c(
                                                        "el-button",
                                                        {
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.openCustomerPop(
                                                                purchaseGoods,
                                                                item
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [_vm._v("编辑客户")]
                                                      )
                                                    ],
                                                    1
                                                  )
                                            ]
                                          )
                                        : _vm._e(),
                                      index > 2
                                        ? _c(
                                            "div",
                                            {
                                              key: index,
                                              staticClass: "flex flex1",
                                              class: { none: item.isShowOrNone }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "good-detail w75"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "flex" },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "flex1 pad15-tb",
                                                          class: {
                                                            bor_bottom_f0:
                                                              item
                                                                .supplyGoodsRelationList
                                                                .length -
                                                                1 >
                                                              index
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "lin_20 mar10-b"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "供应商：" +
                                                                  _vm._s(
                                                                    purchaseGoods.shopName
                                                                  )
                                                              )
                                                            ]
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                " flex"
                                                            },
                                                            [
                                                              _c("img", {
                                                                attrs: {
                                                                  src:
                                                                    purchaseGoods.picUrl,
                                                                  alt: ""
                                                                }
                                                              }),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "flex1"
                                                                },
                                                                [
                                                                  _c(
                                                                    "p",
                                                                    {
                                                                      staticClass:
                                                                        "ellipsis w200"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          purchaseGoods.purchaseGoodsName
                                                                        )
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "p",
                                                                    {
                                                                      staticClass:
                                                                        "f12"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "规格：" +
                                                                          _vm._s(
                                                                            purchaseGoods.spec
                                                                          )
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _c("div", {
                                                                    staticClass:
                                                                      "box10"
                                                                  }),
                                                                  _c("p", [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "pad20-r"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "数量：" +
                                                                            _vm._s(
                                                                              purchaseGoods.purchaseGoodsQuantity
                                                                            )
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _c("span", [
                                                                      _vm._v(
                                                                        "价格：￥" +
                                                                          _vm._s(
                                                                            purchaseGoods.marketPriceStr
                                                                          )
                                                                      )
                                                                    ])
                                                                  ]),
                                                                  _c("p", [
                                                                    purchaseGoods.purchaseGoodsTaxRatio !==
                                                                    0
                                                                      ? _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              "税率： " +
                                                                                _vm._s(
                                                                                  purchaseGoods.purchaseGoodsTaxRatio
                                                                                ) +
                                                                                " %"
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              "税率：免税"
                                                                            )
                                                                          ]
                                                                        )
                                                                  ])
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      ),
                                                      purchaseGoods.isDefault ==
                                                      1
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "flex w110 align_flex_end justify-center pointer flex_column"
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.upGoodSetting(
                                                                        index,
                                                                        purchaseGoods,
                                                                        item
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [_vm._v("编辑")]
                                                              )
                                                            ]
                                                          )
                                                        : _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "flex w110 align_flex_end justify-center pointer flex_column"
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.upGoodSetting(
                                                                        index,
                                                                        purchaseGoods,
                                                                        item
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [_vm._v("编辑")]
                                                              ),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "pad10_t",
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.goodSetting(
                                                                        purchaseGoods,
                                                                        item
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "取消关联"
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              purchaseGoods.isDefault == 1
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "flex flex1 items-center justify-around flex_column f12 text-center pad10-lr",
                                                      class: {
                                                        bor_bottom_f0:
                                                          item
                                                            .supplyGoodsRelationList
                                                            .length -
                                                            1 >
                                                          index
                                                      }
                                                    },
                                                    [
                                                      _c("span", [
                                                        _vm._v(
                                                          "默认为所有客户"
                                                        ),
                                                        _c("br"),
                                                        _vm._v(
                                                          "(除已设置的客户之外)"
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                : _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "flex flex1 items-center justify-around flex_column f12 text-center pad10-lr",
                                                      class: {
                                                        bor_bottom_f0:
                                                          item
                                                            .supplyGoodsRelationList
                                                            .length -
                                                            1 >
                                                          index
                                                      }
                                                    },
                                                    [
                                                      purchaseGoods.customerNameList
                                                        ? _c("span", [
                                                            _vm._v(
                                                              "\n                        " +
                                                                _vm._s(
                                                                  purchaseGoods.customerNameList.split(
                                                                    ","
                                                                  )[0]
                                                                ) +
                                                                "等 " +
                                                                _vm._s(
                                                                  purchaseGoods.customerNameList.split(
                                                                    ","
                                                                  ).length
                                                                ) +
                                                                "个客户\n                      "
                                                            )
                                                          ])
                                                        : _vm._e(),
                                                      _c(
                                                        "el-button",
                                                        {
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.openCustomerPop(
                                                                purchaseGoods,
                                                                item
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [_vm._v("编辑客户")]
                                                      )
                                                    ],
                                                    1
                                                  )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  }),
                                  item.supplyGoodsRelationList.length > 3
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "w75 h45 text-center good-more bor_right_f0"
                                        },
                                        [
                                          !item.isShowOrNone
                                            ? _c("img", {
                                                staticClass: "pointer",
                                                attrs: {
                                                  src: require("./images/pack-up.png"),
                                                  alt: ""
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.isShowOrNone(
                                                      item
                                                    )
                                                  }
                                                }
                                              })
                                            : _vm._e(),
                                          item.isShowOrNone
                                            ? _c("img", {
                                                staticClass: "pointer",
                                                attrs: {
                                                  src: require("./images/unfold.png"),
                                                  alt: ""
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.isShowOrNone(
                                                      item
                                                    )
                                                  }
                                                }
                                              })
                                            : _vm._e()
                                        ]
                                      )
                                    : _vm._e(),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "w75 h45 text-center good-more bor_right_f0"
                                    },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: { icon: "el-icon-plus" },
                                          on: {
                                            click: function($event) {
                                              return _vm.addGoodSetting(item)
                                            }
                                          }
                                        },
                                        [_vm._v("添加")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                2
                              )
                            : _vm._e()
                        ])
                      ])
                    })
                  : _c("div", { staticClass: "t_center pad30-t pad30-b" }, [
                      _vm._v("暂无数据")
                    ])
              ],
              2
            )
          ])
        ],
        1
      ),
      _c("div", { staticClass: "box20" }),
      _c(
        "div",
        { staticClass: "t_right" },
        [
          _c("el-pagination", {
            attrs: {
              background: "",
              "current-page": _vm.currentPage,
              "page-size": 6,
              layout: "total, prev, pager, next, jumper",
              total: _vm.total
            },
            on: { "current-change": _vm.handleCurrentChange }
          })
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "供应商商品选择",
            visible: _vm.dialogVisible,
            "close-on-click-modal": false,
            "before-close": _vm.setGoodCancel,
            width: "1200px"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "setDialog relative" },
            [
              _c("p", { staticClass: "dialog-msg" }, [
                _vm._v(
                  "温馨提示：目前支持销售商品与供应商商品一对多的关系绑定！"
                )
              ]),
              _vm.goodsList.length
                ? _c("p", [
                    _c("span", { staticClass: "pad20-r" }, [
                      _vm._v("当前商品：" + _vm._s(_vm.curSellGood.name))
                    ]),
                    _c("span", [
                      _vm._v("售价：¥" + _vm._s(_vm.curSellGood.marketPriceStr))
                    ])
                  ])
                : _vm._e(),
              _vm.curPurchaseGood.purchaseGoodsName
                ? _c("p", { staticClass: "pad10-t" }, [
                    _c("span", { staticClass: "pad20-r" }, [
                      _vm._v(
                        "当前关联供应商：" +
                          _vm._s(_vm.curPurchaseGood.shopName)
                      )
                    ]),
                    _c("span", { staticClass: "pad20-r" }, [
                      _vm._v(
                        "当前关联商品：" +
                          _vm._s(_vm.curPurchaseGood.purchaseGoodsName)
                      )
                    ]),
                    _c("span", { staticClass: "pad20-r" }, [
                      _vm._v(
                        "售价：¥" + _vm._s(_vm.curPurchaseGood.marketPriceStr)
                      )
                    ]),
                    _c("span", [
                      _vm._v(
                        "数量： " +
                          _vm._s(_vm.curPurchaseGood.purchaseGoodsQuantity)
                      )
                    ])
                  ])
                : _vm._e(),
              _c(
                "div",
                { staticClass: "flex items-start flex-wrap mar20-t mar20-b" },
                [
                  _c(
                    "div",
                    { staticClass: "flex items-center" },
                    [
                      _c("div", { staticClass: "lable" }, [_vm._v("供应商：")]),
                      _c(
                        "el-select",
                        {
                          attrs: { filterable: "", placeholder: "请选择" },
                          model: {
                            value: _vm.supplierId,
                            callback: function($$v) {
                              _vm.supplierId = $$v
                            },
                            expression: "supplierId"
                          }
                        },
                        _vm._l(_vm.supplierList, function(item) {
                          return _c("el-option", {
                            key: item.shopIdStr,
                            attrs: { label: item.name, value: item.shopIdStr }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "flex items-center mar15-l" },
                    [
                      _c("div", { staticClass: "lable" }, [
                        _vm._v("商品名称：")
                      ]),
                      _c("el-input", {
                        attrs: { placeholder: "请输入商品名称" },
                        model: {
                          value: _vm.search_name,
                          callback: function($$v) {
                            _vm.search_name =
                              typeof $$v === "string" ? $$v.trim() : $$v
                          },
                          expression: "search_name"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-button",
                    {
                      staticClass: "mar15-l",
                      attrs: { icon: "el-icon-search", type: "primary" },
                      on: { click: _vm.searchSetGood }
                    },
                    [_vm._v("查询")]
                  )
                ],
                1
              ),
              _c(
                "el-table",
                {
                  ref: "multipleTable",
                  staticClass: "setTable",
                  staticStyle: { width: "100%" },
                  attrs: {
                    border: "",
                    data: _vm.searchList,
                    "max-height": "500",
                    "tooltip-effect": "dark"
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "", width: "65" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-radio",
                              {
                                attrs: {
                                  disabled: scope.row.isRelationType === "1",
                                  label: scope.row.goodsId
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.radioChange(scope)
                                  }
                                },
                                model: {
                                  value: _vm.goodRadio,
                                  callback: function($$v) {
                                    _vm.goodRadio = $$v
                                  },
                                  expression: "goodRadio"
                                }
                              },
                              [_vm._v(" ")]
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { label: "商品", width: "300" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "div",
                              { staticClass: "flex table-good-details" },
                              [
                                scope.row.isRelationType === "1"
                                  ? _c(
                                      "el-tooltip",
                                      {
                                        staticClass: "item",
                                        attrs: {
                                          effect: "dark",
                                          content: "已关联",
                                          placement: "top-start"
                                        }
                                      },
                                      [
                                        _c("img", {
                                          attrs: {
                                            src: scope.row.picUrl,
                                            alt: ""
                                          }
                                        })
                                      ]
                                    )
                                  : _c("img", {
                                      attrs: { src: scope.row.picUrl, alt: "" }
                                    }),
                                _c("div", [
                                  _c("p", { staticClass: "ellipsis w200" }, [
                                    _vm._v(_vm._s(scope.row.name))
                                  ]),
                                  _c("p", [
                                    _vm._v("规格：" + _vm._s(scope.row.spec))
                                  ])
                                ])
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "marketPriceStr",
                      label: "价格",
                      width: "120"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "status", label: "状态", width: "120" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("p", [
                              _vm._v(
                                _vm._s(scope.row.status === 5 ? "上架" : "下架")
                              )
                            ])
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "shopName",
                      label: "供应商",
                      width: "200",
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "num", width: "200", label: "比例设置" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("el-input", {
                              attrs: {
                                placeholder: "请输入",
                                disabled: _vm.goodRadio !== scope.row.goodsId
                              },
                              on: {
                                input: function($event) {
                                  return _vm.inputChange(scope, $event)
                                }
                              },
                              model: {
                                value: scope.row.num,
                                callback: function($$v) {
                                  _vm.$set(
                                    scope.row,
                                    "num",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "scope.row.num"
                              }
                            })
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "taxRatio",
                      width: "150",
                      label: "商品税率"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  disabled: _vm.goodRadio !== scope.row.goodsId,
                                  placeholder: "请选择"
                                },
                                model: {
                                  value: scope.row.taxRatio,
                                  callback: function($$v) {
                                    _vm.$set(scope.row, "taxRatio", $$v)
                                  },
                                  expression: "scope.row.taxRatio"
                                }
                              },
                              _vm._l(_vm.taxRatioOptions, function(item) {
                                return _c("el-option", {
                                  key: item.value,
                                  attrs: {
                                    label: item.label,
                                    value: item.value
                                  }
                                })
                              }),
                              1
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.setGoodCancel } }, [
                _vm._v("取 消")
              ]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.setGoodSure } },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "选择客户",
            visible: _vm.customerPop.chooseClientVisible,
            "close-on-click-modal": false,
            width: "735px",
            "show-close": false,
            "custom-class": "chooseClientPop"
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.customerPop, "chooseClientVisible", $event)
            }
          }
        },
        [
          _c("div", [
            _c("div", { staticClass: "clear ps_search_wrap" }, [
              _c(
                "span",
                { staticClass: "float-left pad15_r lin_30 inlineblock" },
                [_vm._v("客户名称")]
              ),
              _c(
                "div",
                { staticClass: "ps_search float-left" },
                [
                  _c("el-input", {
                    attrs: { type: "text", placeholder: "请输入客户名称" },
                    model: {
                      value: _vm.customerPop.searchCustomer.name,
                      callback: function($$v) {
                        _vm.$set(_vm.customerPop.searchCustomer, "name", $$v)
                      },
                      expression: "customerPop.searchCustomer.name"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "float-left client_pop_query",
                  on: {
                    click: function($event) {
                      return _vm.listCustomer(1)
                    }
                  }
                },
                [_vm._v("搜索")]
              )
            ]),
            _c("div", { staticClass: "box30" }),
            _c("div", { staticClass: "clear ps_search_wrap" }, [
              _c(
                "span",
                { staticClass: "float-left pad15_r lin_30 inlineblock" },
                [_vm._v("客户分组")]
              ),
              _c(
                "div",
                { staticClass: "ps_search float-left" },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择客户分组", clearable: "" },
                      model: {
                        value: _vm.customerPop.searchCustomer.groupId,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.customerPop.searchCustomer,
                            "groupId",
                            $$v
                          )
                        },
                        expression: "customerPop.searchCustomer.groupId"
                      }
                    },
                    _vm._l(_vm.customerPop.groupDataList, function(item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            ]),
            _c("div", { staticClass: "box20" }),
            _c("div", { staticClass: "clear ps_group_list" }, [
              _c("div", { staticClass: "float-left client_list_all" }, [
                _c("p", [_vm._v("我的客户")]),
                _c("div", { staticClass: "client_list_pop_main" }, [
                  _c(
                    "ul",
                    { staticClass: "clear" },
                    _vm._l(_vm.customerPop.customerDataList, function(
                      item,
                      index
                    ) {
                      return _c(
                        "li",
                        {
                          key: index,
                          on: {
                            click: function($event) {
                              return _vm.customerDialogSelect(item)
                            }
                          }
                        },
                        [
                          item.isCheck
                            ? _c("div", {
                                staticClass: "client_list_mask",
                                domProps: {
                                  innerHTML: _vm._s(
                                    "归属采购商品：" + item.attrName
                                  )
                                }
                              })
                            : _vm._e(),
                          _c(
                            "p",
                            { staticClass: "group_item_name ellipsis_two" },
                            [_vm._v(_vm._s(item.name))]
                          ),
                          _c("p", [
                            _vm._v(
                              "身份：" +
                                _vm._s(item.targetType === 1 ? "个人" : "企业")
                            )
                          ])
                        ]
                      )
                    }),
                    0
                  )
                ])
              ]),
              _c("div", { staticClass: "float-right client_list_me" }, [
                _c("p", [_vm._v("已选客户")]),
                _c("div", { staticClass: "client_list_pop_main" }, [
                  _c(
                    "ul",
                    { staticClass: "clear" },
                    _vm._l(_vm.conCustomerSel.customerSelList, function(
                      item,
                      index
                    ) {
                      return _c("li", { key: index }, [
                        _c("i", {
                          staticClass: "iconfont icon-shibai fb",
                          on: {
                            click: function($event) {
                              return _vm.removeSelectCustomer(item)
                            }
                          }
                        }),
                        _c(
                          "p",
                          { staticClass: "group_item_name ellipsis_two" },
                          [_vm._v(_vm._s(item.name))]
                        ),
                        _c("p", [
                          _vm._v(
                            "身份：" +
                              _vm._s(item.targetType === 1 ? "个人" : "企业")
                          )
                        ])
                      ])
                    }),
                    0
                  )
                ])
              ])
            ])
          ]),
          _c("div", { staticClass: "box20" }),
          _c("el-pagination", {
            attrs: {
              background: "",
              "current-page": _vm.customerPop.currentPageCustomer,
              "page-sizes": [6, 10, 20],
              "page-size": _vm.customerPop.pageSize,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.customerPop.totalCount
            },
            on: {
              "size-change": _vm.handleSizeChangeCustomer,
              "current-change": _vm.handleCurrentChangeCustomer
            }
          }),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.customerDialogConfirm }
                },
                [_vm._v("确 认")]
              ),
              _c("el-button", { on: { click: _vm.customerDialogClose } }, [
                _vm._v("取 消")
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }